<div class="adtabcontent">
  <app-column-header [headerData]="headerData" (topbtnaction)="onSubmit()"></app-column-header>
  <form [formGroup]="menuForm" (ngSubmit)="onSubmit()">
    <div class="newcardblocks">
      <div class="contents">
        <div class="filedgrid thrcol">
          <div class="colbox">
            <div class="formGroup">
              <label class="control-label">Menu Name</label>
              <input type="text" formControlName="menuName" class="form-control inputText" maxlength="25"
                [ngClass]="{'is-invalid': submitted && f.menuName.errors}" placeholder="Enter Menu Name">
            </div>
          </div>
          <div class="colbox">
            <div class="formGroup" *ngIf="menuListdata.length>0">
              <label class="control-label">Module Name</label>
              <ng-select class="form-control" palceholder="-Select-" formControlName="parentMenuId"
                [items]="menuListdata" bindLabel="gstibo_menu_name" bindValue="gstibo_menu_id" appendTo="body"
                [ngClass]="{'is-invalid': submitted && f.parentMenuId.errors}" (change)="module_Change($event)">
              </ng-select>
            </div>
          </div>

          <div class="colbox">
            <div class="formGroup">
              <label class="control-label">Icon</label>
              <ng-select class="form-control" palceholder="-Select-" formControlName="menuIcon" [items]="menuIcons"
                bindLabel="name" bindValue="id" appendTo="body"
                [ngClass]="{'is-invalid': submitted && f.menuIcon.errors}" style="width: 30rem;">
              </ng-select>
            </div>
          </div>
          <div class="colbox">
            <div style="padding-top: 3px !important;">
              <svg class="icon iconstyle">
                <use [attr.xlink:href]="srcPath.menuIconPath + menuForm.value.menuIcon"></use>
              </svg>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <hr style="height: 0.5px;">
        <div class="filedgrid thrcol">
          <div class="colbox">
            <div class="formGroup" *ngIf="menuListdata.length>0">
              <label class="control-label">Is Dynamic</label>
              <ng-select class="form-control" palceholder="-Select-" formControlName="isDynamicmenu"
                [items]="booleanOptions" bindLabel="name" (change)="dynamic_Change($event)" bindValue="id"
                appendTo="body" [ngClass]="{'is-invalid': submitted && f.isDynamicmenu.errors}"></ng-select>
            </div>
          </div>
          <div class="colbox" *ngIf="isDynamicPage=='true'">
            <div class="formGroup">
              <label class="control-label">Menu Order</label>
              <input type="number" formControlName="menuorderId" class="form-control inputText">
              <!-- <ng-select class="form-control" palceholder="-Select-" formControlName="menuorderId" [items]="dynamicorderlist"
                bindLabel="id" bindValue="id" appendTo="body"
                [ngClass]="{'is-invalid': submitted && f.menuIcon.errors}"></ng-select>  -->
            </div>
          </div>
          <div class="colbox" *ngIf="isDynamicPage=='false'">
            <div class="formGroup">
              <label class="control-label">Listing Order</label>
              <ng-select class="form-control" palceholder="-Select-" formControlName="lstorder"
                [items]="staticorderlist" bindLabel="id" bindValue="id" appendTo="body"
                [ngClass]="{'is-invalid': submitted && f.lstorder.errors}">
              </ng-select>
            </div>
          </div>
          <div class="colbox" >
            <div class="formGroup">
              <label class="control-label">Is Hide</label>
              <ng-select class="form-control" palceholder="-Select-" formControlName="isHide"
              [items]="booleanOptions" bindLabel="name"  bindValue="id"
              appendTo="body" ></ng-select>
              </div>
          </div>
        </div>
       
        <div class="filedgrid thrcol" *ngIf="isDynamicPage =='false' || showDivParent == true">
          <!-- <div > -->
          <div class="colbox" *ngIf="isDynamicPage =='false' || showDivParent == true">
            <div class="formGroup">
              <div class="formGroup">
                <label class="control-label">Show as Parent Module</label>
                <ng-select class="form-control" palceholder="-Select-" formControlName="show_ParentModule"
                  [items]="booleanOptions" bindLabel="name" (change)="Isparent_Change($event)" bindValue="id"
                  appendTo="body" [ngClass]="{'is-invalid': submitted && f.show_ParentModule.errors}"></ng-select>
              </div>
            </div>
          </div>
          <div class="colbox">
            <div class="formGroup">
              <label class="control-label">Show in Dynamic Menu</label>
              <ng-select class="form-control" palceholder="-Select-" formControlName="showunder_Dynamicmenu"
                [items]="booleanOptions" bindLabel="name" (change)="Isdynamic_Change($event)" bindValue="id"
                appendTo="body" [ngClass]="{'is-invalid': submitted && f.showunder_Dynamicmenu.errors}"></ng-select>
            </div>
          </div>
          <div class="colbox"
            *ngIf="(isParentModule =='true' && Isshowin_dynamicMdoule == 'false')||(isParentModule =='false' && Isshowin_dynamicMdoule == 'false') ">
            <div class="formGroup">
              <label class="control-label">Parent Module</label>
              <ng-select class="form-control" palceholder="-Select-" formControlName="ParentStMenuId"
                [items]="staticPageslist" bindLabel="gstibo_menu_name" (change)="IparentstMenu_Change($event)"
                bindValue="gstibo_menu_id" appendTo="body"
                [ngClass]="{'is-invalid': submitted && f.ParentStMenuId.errors}"></ng-select>
            </div>
          </div>
          <div class="colbox" *ngIf="Isshowin_dynamicMdoule =='true' ">
            <!-- {{ isParentModule + Isshowin_dynamicMdoule }}  isParentModule =='false' && Isshowin_dynamicMdoule == 'true' -->
            <div class="formGroup">
              <label class="control-label">Parent Dynamic Module</label>
              <ng-select class="form-control" palceholder="-Select-" formControlName="parentdynMenuId"
                [items]="menuListdata" bindLabel="gstibo_menu_name" (change)="IparentdynMenu_Change($event)"
                bindValue="gstibo_menu_id" appendTo="body"
                [ngClass]="{'is-invalid': submitted && f.parentdynMenuId.errors}"></ng-select>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <hr>
        <!-- </div> -->
        <div class="filedgrid thrcol">
          <div class="colbox">
            <div class="radioGroup ">
              <input name="linkPage" id="linkPage" class="checkBox" type="checkbox"
                [checked]="(ispagelinked == 0 ? false : true )" formControlName="ispagelinked" />
              <label class="control-label" for="linkPage"><span></span>Link Page
              </label>
            </div>
          </div>
          <div class="colbox">
            <div class="radioGroup ">
              <input class="checkBox" type="checkbox" id="isSubmenu" formControlName="isSubmenu" 
              [checked]="(isSubmenu == 0 ? false : true )"/>
              <label class="control-label" for="isSubmenu"><span></span>Is Submenu
              </label>
            </div>
          </div>
          <div class="colbox">
            <div class="radioGroup ">
              <input class="checkBox" type="checkbox" id="withChildMenues" formControlName="isWithChildMenues" />
              <label class="control-label" for="withChildMenues"><span></span>With Child Menues
              </label>
            </div>
          </div>
          <div class="colbox">
            <div class="radioGroup ">
              <input class="checkBox" type="checkbox" id="withChildInnerPage" formControlName="isWithChildInnerPage" />
              <label class="control-label" for="withChildInnerPage"><span></span>With Child Inner Page
              </label>
            </div>
          </div>
        </div>
        <div class="filedgrid thrcol" >
          <div class="colbox">
            <div class="formGroup" *ngIf="menuForm.value.ispagelinked=='1' && appPageList.length>0">
              <ng-select class="form-control" palceholder="-Select-" formControlName="pageId" [items]="appPageList"
                bindLabel="pageName" bindValue="pageId" appendTo="body"
                [ngClass]="{'is-invalid': submitted && f.menuIcon.errors}"></ng-select>
            </div>
          </div>
          <div class="colbox">
            <div class="formGroup"  *ngIf="menuForm.value.isSubmenu=='1' && subMenuList.length>0">
              <ng-select class="form-control" palceholder="-Select-" formControlName="subMenuPageId" [items]="subMenuList"
                bindLabel="pageName" bindValue="pageId" appendTo="body"
                [ngClass]="{'is-invalid': submitted && f.menuIcon.errors}"></ng-select>
            </div>
          </div>
        </div>
        <!-- (change)="getSelectedPage(pageId)" (change)="changeIcon(menuIcon)"   -->
      </div>
    </div>
  </form>
</div>